import { render, staticRenderFns } from "./TestInfoDialog.vue?vue&type=template&id=4d5a9d66&scoped=true"
import script from "./TestInfoDialog.vue?vue&type=script&lang=ts"
export * from "./TestInfoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a9d66",
  null
  
)

export default component.exports